module.exports = __webpack_public_path__ + "static/techkid.14e67640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/techkid.jpg
// module id = 363
// module chunks = 35783957827783